import { deliveryCollection } from "@/firebase";

const state = {
  delivery: {}
};

const getters = {};

const actions = {
  getDelivery({ commit }, payload) {
    deliveryCollection
      .where("client", "==", payload)
      .orderBy("name", "asc")
      .get()
      .then(querySnapshot => {
        let tempData = [];
        querySnapshot.forEach(doc => {
          tempData.push(Object.assign(doc.data(), { id: doc.id }));
        });
        commit("getDelivery", tempData);
      });
  },
  addDelivery({ commit }, payload) {
    deliveryCollection.add(payload).then(docRef => {
      commit("addDelivery", Object.assign(payload, { id: docRef.id }));
    });
  },
  removeDelivery({ commit }, payload) {
    deliveryCollection
      .doc(payload)
      .delete()
      .then(() => {
        commit("removeDelivery", payload);
      });
  },
  editDelivery({ commit }, payload) {
    deliveryCollection
      .doc(payload.id)
      .set(payload)
      .then(() => {
        commit("editDelivery", payload);
      });
  }
};

const mutations = {
  getDelivery(state, payload) {
    state.delivery = payload;
    //console.log(state.delivery);
  },
  addDelivery(state, payload) {
    state.delivery.push(payload);
  },
  removeDelivery(state, payload) {
    const index = state.delivery.findIndex(item => item.id == payload);
    state.delivery.splice(index, 1);
  },
  editDelivery(state, payload) {
    const index = state.delivery.findIndex(item => item.id == payload.id);
    state.delivery.splice(index, 1, payload);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
